export function scrollToFirstError() {
  const element = document.querySelector('.field-error, .error');
  element?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
  return !element;
}
